import styled from '@emotion/styled';
import React, { useRef } from 'react';
import { useButton } from 'react-aria';

import glyphStyles from '../../../components/common/Glyph.module.css';
import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';

import { Glyph } from '../../../components/common/Glyph';

export function ViewButton(props) {
  const ref = useRef();
  const button = useButton(props, ref);

  return (
    <ViewButton.Root {...button.buttonProps} as={props.as} ref={ref}>
      {props.children}
    </ViewButton.Root>
  );
}

ViewButton.Forward = function Forward(props) {
  return (
    <ViewButton {...props} as={ViewButton.Forward.Root}>
      {props.children}

      <Glyph
        color={theme.color.text_link}
        size={theme.icon.size_small}
        source={glyph.core.chevronRightBold}
        mirrorRTL={true}
      />
    </ViewButton>
  );
};

ViewButton.Backward = function Backward(props) {
  return (
    <ViewButton {...props} as={ViewButton.Backward.Root}>
      <Glyph
        color={theme.color.text_link}
        size={theme.icon.size_small}
        source={glyph.core.chevronLeftBold}
        mirrorRTL={true}
      />

      {props.children}
    </ViewButton>
  );
};

ViewButton.Root = styled.button`
  padding: ${su(1, 0)};
  color: ${theme.color.text_link};
  font-size: ${theme.fontSize.small};
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    color: ${theme.color.text_link_hover};
    text-decoration: underline;

    .${glyphStyles.root} {
      color: ${theme.color.text_link_hover};
    }
  }
`;

ViewButton.Forward.Root = styled(ViewButton.Root)`
  .${glyphStyles.root} {
    margin-inline-start: ${su(1)};
  }
`;

ViewButton.Backward.Root = styled(ViewButton.Root)`
  .${glyphStyles.root} {
    margin-inline-end: ${su(1)};
  }
`;
